import { useQuery } from '@tanstack/react-query';
import { getEntitiesList } from 'config/requests/userActions';

export function useGetEntities() {
  return useQuery({ queryKey: ['entities'], queryFn: getEntitiesList });
}
